<div class="list-wrapper">
    <div class="list-header">
        <h1>Lister:&nbsp;<span class="header-object-type">Prosjekt</span></h1>
        <div class="list-close" (click)="onCloseSideBar()"></div>
    </div>
    <div class="list-content">
        <div class="selection">
            <div class="header-info-text">{{ numberOfProjects() > 0 ? numberOfProjects() : "Ingen" }} prosjekter i
                utvalget</div>
            @if (numberOfProjects() > 0) {
            <div class="icon-btn download" [class.disabled]="isExporting()" (click)="exportToExcel()">
                <div class="label">
                    Eksporter utvalg til Excel
                    @if(isExporting()) {
                    <div class="loader">
                        <ev-logo-loader width="25px" label="Henter prosjekter" />
                    </div>
                    }
                </div>

            </div>
            }
        </div>
    </div>
</div>